"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Person = function Person(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/general/person-person" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-person" + unique,
    xlinkHref: "#path-1-person" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-person" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.1559693,11 C15.1559693,11 17.4468994,11.8778687 17.6571045,12.7893677 C17.6604891,12.7991637 18.4280754,15.4419443 19.9598634,20.7177095 C20.1157681,21.2475323 19.8126476,21.8034243 19.2828249,21.959329 C19.1911546,21.9863037 19.0960911,22 19.0005344,22 L4.99920734,22 C4.44692259,22 3.99920734,21.5522847 3.99920734,21 C3.99920734,20.9044433 4.01290361,20.8093799 4.03987836,20.7177095 L6.39394435,12.7177095 C6.65740967,11.8024902 8.15239021,11.4195439 9.23397798,11 C10.4633318,10.6756727 11,10.3423394 11,10 C11,9.92810563 10.9875917,9.85660845 10.962775,9.78550848 C9.81665279,9.29323776 8.99920734,8.00799157 8.99920734,6.5 C8.99920734,6.33023933 8.99920734,6.15701294 8.99920734,6 C8.99920734,5.86447144 8.99920734,5.66976067 8.99920734,5.5 C8.99920734,3.56700338 10.3423531,2 11.9992073,2 C13.6560616,2 14.9992073,3.56700338 14.9992073,5.5 C14.9992073,5.66976067 15.0192289,5.83669851 14.9992073,6 C15.0192289,6.16330149 14.9992073,6.33023933 14.9992073,6.5 C14.9992073,7.47934409 14.6544357,8.36474148 14.0987714,9 C13.6614266,9.40248048 13.3194991,9.65885862 13.0729887,9.76913441 C13.027095,9.84453048 13,9.92205095 13,10 C13,10.4905104 15.1559693,11 15.1559693,11 Z M11.6319857,14 C11.5546138,14 11.4899364,14.0588496 11.482652,14.1358779 L11.0033842,19.2038636 C10.9984849,19.2556707 11.0207868,19.3063156 11.0623112,19.3376796 L11.9050949,19.9742483 C11.9585932,20.0146565 12.03241,20.0146565 12.0859084,19.9742483 L12.9286921,19.3376796 C12.9702165,19.3063156 12.9925184,19.2556707 12.9876191,19.2038636 L12.5083513,14.1358779 C12.5010669,14.0588496 12.4363894,14 12.3590176,14 L11.6319857,14 Z M11.1265566,11.7965619 C11.1206219,11.7985874 11.11482,11.8009831 11.1091851,11.8037349 C11.0347444,11.8400874 11.0038679,11.929903 11.0402204,12.0043436 L11.4394341,12.8218314 C11.464588,12.8733401 11.5168984,12.9060094 11.5742209,12.9060094 L12.4167831,12.9060094 C12.4741056,12.9060094 12.526416,12.8733401 12.5515698,12.8218314 L12.9507826,12.0043456 C12.9535346,11.9987101 12.9559305,11.9929076 12.9579562,11.9869723 C12.9847137,11.9085698 12.9428471,11.8233207 12.8644447,11.7965632 L11.995481,11.5 L11.1265566,11.7965619 Z",
    fill: "inherit",
    id: "path-1-person" + unique
  }))));
};

Person.propTypes = propTypes;
var _default = Person;
exports["default"] = _default;